import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Spinner from "~/components/ui/spinner/Spinner";
import { useAuth } from "~/contexts/AuthProvider";
import { PENDING_INVITE_UUID_STORAGE_KEY } from "~/helpers/consts";
import { routes } from "~/router";
import { isWhiteLabel } from "~/utils/white-label";

import styles from "./InvitationPage.module.scss";

const InvitationPage = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {
    if (!uuid) return;

    // only write token to localStorage and consume it later with PendingInvitationHandler
    localStorage.setItem(PENDING_INVITE_UUID_STORAGE_KEY, uuid);

    // White-label login has no "Sign up" link, so guests go straight to
    // sign-up, which picks the invitation uuid up from localStorage.
    const target =
      isWhiteLabel() && !token ? routes.auth.signUp() : routes.home();
    navigate(target, { replace: true });
  }, [uuid]);

  return (
    <div className={styles.centeredSpinner}>
      <Spinner />
    </div>
  );
};

export default InvitationPage;
